module.exports = __webpack_public_path__ + "img/symbol_anker@2x.409e752.webp";